// src/pages/Reviews.js
import React from "react";
import { motion } from "framer-motion";
import Reviews from "../components/Reviews";


const ReviewsPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      transition={{ duration: 0.5 }}
    >
      <Reviews />
    </motion.div>
  );
};

export default ReviewsPage;